export default __webpack_public_path__ + "static/media/gr.bb62b9f7.svg";